import React, { Component } from 'react';
import { Button, Icon, Row, Col, Input } from 'antd';
import Papa from 'papaparse'

import { uploadFileOrder } from '../../../../../../utils/orders'
import hanldeException from '../../../../../../services/handleException';
import { alertError, alertSuccess } from '../../../../../../services/dialog'
import { getIEVersion } from '../../../../../../services/helper'
import lang from '../../../../../../languages/en'
import styles from './styles.css'

// const MAX_CSV_ROW = 10000
const MAX_CSV_ROW = 10000000

class Step1 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileUpload: null,
        }
    }

    getLength = (data) => {
        let length = -1

        for(let i =0;i < data.length; i++) {
            for(let j=0; j< data[i].length; j++) {
                if(data[i][j]) {
                    length ++
                    break
                }
            }
        }

        return length
    }

    handleFile = (file, allowedExtensions, extension) => {
        if (allowedExtensions.indexOf(extension) !== -1) {
            this.props.handleUploadFile(true)

            const that = this
            Papa.parse(file, {
                complete: function(results) {
                    that.props.handleUploadFile(false)
                    if(that.getLength(results.data) > MAX_CSV_ROW) {
                        alertError(lang.item_name_exceed_10000_title, lang.item_name_exceed_10000_content)
                    } else {
                        that.props.onChangeUploadFile(file)
                        that.props.changeActionStep(2)
                    }
                }
            });
        } else {
            alertError(lang.type_file_upload_invalid, lang.format_csv_file_upload);
        }
    }

    validateFile = (file) => {
        let extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
        let allowedExtensions = ['csv']
        this.handleFile(file, allowedExtensions, extension)
    }

    dropHandler = (ev) => {
        ev.preventDefault();
        if (getIEVersion() > 1) {
            let file = ev.dataTransfer.files[0]
            if (file) {
                this.validateFile(file)
            }
        } else if (ev.dataTransfer.items) {
            let file = ev.dataTransfer.files[0]
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    file = ev.dataTransfer.items[i].getAsFile();
                }
            }
            if (file) {
                this.validateFile(file)
            }
        }

    }

    dragOverHandler = (ev) => {
        ev.preventDefault();
    }

    browseFile = () => {
        this.refInput.input.click()
    }

    onSelectFile = (e) => {
        const file = e.target.files[0]
        this.validateFile(file)
    }

    render() {
        return (
            <div id="step1">
                <div className="import-item-name-browse-file">
                    <Row className="row-1 text-center">
                        <Col className="description" span={11}>
                            <div>Choose file to upload</div>
                        </Col>
                        <Col span={13}>
                            <div id='upload-file'>
                                <div className='upload-file-input'>
                                    <Button className="browse-button" onClick={this.browseFile}>
                                        <label
                                            className='button-upload-file-order-up'
                                        >
                                            <div className='icon'><Icon type="upload" /> Browse</div>
                                        </label>
                                    </Button>
                                </div>
                            </div>
                            <div  className="description-drag">Drag and drop ITEM MASTER FILE to this window or select ITEM MASTER FILE</div>
                        </Col>
                    </Row>
                </div>
                <Input
                    ref={ref => this.refInput = ref}
                    value={this.state.fileName}
                    type="file"
                    accept=".csv"
                    className="hidden"
                    onChange={this.onSelectFile}
                />
            </div>
        );
    }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/import-panel/step1/index.js